import { GLC_Container, groupLessonCellVariants } from "./GroupLessonCell.styled";
import { GrandChartGroupLessonStore } from "../../../../../../../../stores/grand-charts/grand-chart-group-lesson.store";
import { ServiceName } from "../../../../../../../../constants";
import { GroupLessonItem } from "./GroupLessonItem";

interface GroupLessonCellProps {
	service: ServiceName;
	grandChartGroupLessonsStore: GrandChartGroupLessonStore[];
}

export const GroupLessonCell = ({ service, grandChartGroupLessonsStore }: GroupLessonCellProps) => {
	return (
		<GLC_Container variants={groupLessonCellVariants}>
			{grandChartGroupLessonsStore.map((groupLessonItemStore) => {
				return (
					<GroupLessonItem
						key={groupLessonItemStore.id}
						service={service}
						groupLessonItemStore={groupLessonItemStore}
					/>
				);
			})}
		</GLC_Container>
	);
};
